import { render, staticRenderFns } from "./MenuInfo.vue?vue&type=template&id=09314cf8&scoped=true"
import script from "./MenuInfo.vue?vue&type=script&lang=ts"
export * from "./MenuInfo.vue?vue&type=script&lang=ts"
import style0 from "./MenuInfo.vue?vue&type=style&index=0&id=09314cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09314cf8",
  null
  
)

export default component.exports